import React from 'react';

const Footer: React.FC = () => {
  return (
    <footer className="footer bg-light border-top mt-auto">
      <div className="container-fluid">
        <div className="text-center py-3">
          <p className="mb-0 text-muted small">&copy; 2025 Regiane Faia. Todos os direitos reservados.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;